module.exports = __webpack_public_path__ + "img/tanker_idle.39afd91f.svg";